import wasteManagementClient from './wasteManagementClient';
import { wasteManagementUrls } from '../appConfig';

export default class ModulesService {
  static getModules(customerId, ignoreCache = false) {
    return wasteManagementClient.get(wasteManagementUrls.modules, {
      params: {
        customerId,
      },
      cache: { ignoreCache },
    }).then(response => {
      if (response.data && response.status === 200) {
        return response.data;
      } else {
        return [];
      }
    }).catch(error => {
      console.error(error);
      throw error;
    });
  }
}
